import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { Color } from 'src/app/shared/enums/utils/colors';

export interface Feature {
  title?: string;
  subtitle?: string;
  template?: TemplateRef<any>;

  standard: FeatureValue;
  custom: FeatureValue;

  collapsibleId?: string; // For collapsible sub-features
  isCollapsed?: boolean; // For collapsible sub-features
  subFeatures?: Feature[];  // For collapsible sub-features
}

export interface FeatureValue {
  icon?: string;
  text?: string;
  color?: Color;
  template?: TemplateRef<any>;
  progressPercent?: number;
}

@Component({
  selector: 'app-lp-pricing-variants',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lp-pricing-variants.component.html',
  styleUrls: ['./lp-pricing-variants.component.scss'],
})
export class LpPricingVariantsComponent implements AfterViewInit {
  Math = Math;
  

  features: Feature[] = [];
  progressRadius = 15.91549430918954;
  uncollapsedIds: string[] = [];

  constructor(
    private navService: NavigationService
  ) {}

  onToggle(id: string) {
    // find elements with class 'collapsible'
    const allCollapsibleElements = document.getElementsByClassName('collapsible');
    // filter them by data-collapsible-id attribute
    const collapsibleElements = Array.from(allCollapsibleElements).filter(e => e.getAttribute('data-collapsible-id') === id);


    if (this.uncollapsedIds.includes(id)) {
      this.uncollapsedIds = this.uncollapsedIds.filter(i => i !== id);
      
      // remove 'active' class from all collapsibleElements
      collapsibleElements.forEach(e => e.classList.remove('active'));
    } else {
      this.uncollapsedIds.push(id);

      // add 'active' class from all collapsibleElements
      collapsibleElements.forEach(e => e.classList.add('active'));
    }
  }

  ngAfterViewInit(): void {
    this.initFeatures();
    
  }
  
  onDemo() {
    this.navService.goToArrangeMeeting();
  }

  getProgressColor(prct: number) {
    if (prct <= 25) {
      return 'var(--l-danger)';
    } else if (prct <= 75) {
      return 'var(--l-warn)';
    } else {
      return 'var(--l-success)';
    }
  }


  @ViewChild('qweqweqwe') qweqweqwe!: TemplateRef<any>;
  @ViewChild('qweqweqwe1') qweqweqwe1!: TemplateRef<any>;
  @ViewChild('qweqweqwe2') qweqweqwe2!: TemplateRef<any>;
  @ViewChild('opolol') opolol!: TemplateRef<any>;
  @ViewChild('nextBestOfferTemplate') nextBestOfferTemplate!: TemplateRef<any>;
  
  private initFeatures() {
    this.features = [
      {
        template: this.qweqweqwe,
        standard: {
          template: this.qweqweqwe1,
        },
        custom: {
          template: this.qweqweqwe2,
        },
      },


      {
        title: 'Počet vypsaných událostí',
        standard: {
          text: 'Neomezeně',
        },
        custom: {
          text: 'Neomezeně',
        },
      },


      {
        title: 'Počet členů týmu',
        standard: {
          text: 'Neomezeně',
        },
        custom: {
          text: 'Neomezeně',
        },
      },


      {
        title: 'Počet zákazníků',
        standard: {
          text: 'Neomezeně',
        },
        custom: {
          text: 'Neomezeně',
        },
      },


      {
        title: 'Přizpůsobení systému na míru',
        standard: {
          icon: 'pi pi-times',
          color: Color.DANGER,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
      },


      {
        title: 'Rozvoj a pravidelné aktualizace',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
      },


      {
        collapsibleId: 'vypsani-akce',
        title: 'Vypsání vaší akce + prodejní stránka',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Vypisování dlouhodobých či vícedenních kurzů, seminářů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Vypisování jednorázových kurzů, workshopů, seminářů, webinářů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Vypisování konference',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Vypisování festivalů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Vypsání služeb na objednávku',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Balíčky - možnost definovat balíčky z více různých prodejních položek',
            standard: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
            custom: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            subtitle: 'Sdílení kapacity míst',
            standard: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
            custom: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
          },
          {
            collapsibleId: 'vypsani-akce',
            template: this.opolol,
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },


      {
        collapsibleId: 'chytre-formulare',
        title: 'Chytré rezervační a prodejní formuláře',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Formulářový editor',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Povinné a volitelné položky',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Datové typy IČ, Datum narození, Telefonní číslo, E-mail, Souhlas, ...',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Rezervace pro jednotlivce',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Prodej vstupenek',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Rezervace pro skupiny jednotlivců',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Rezervace pro páry nebo páry a jednotlivce',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Rezervace kdy rodič hlásí děti',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Rezervace kdy dospělý hlásí skupinu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Rezervace / poptávky služeb na objednávku',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Prodej doplňkových produktů a služeb (merchendise, ubytování, ...)',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Možnost platby na fakturu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'chytre-formulare',
            subtitle: 'Chytrý sběr zákaznických dat, který zákazníky nenutí vyplňovat opakovaně dříve již poskytnuté informace (kterým zatím nevypršela doba platnosti)',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },



      {
        collapsibleId: 'online-prodej',
        title: 'On-line prodej',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'online-prodej',
            subtitle: 'Online platby kartou pomocí platebních bran',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'online-prodej',
            subtitle: 'QR platby, platby bankovním převodem',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'online-prodej',
            subtitle: 'One-stop shop nákupní proces, optimalizovaný pro jednorázový prodej položek (např. jednorázový seminář či webinář)',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'online-prodej',
            subtitle: 'Multi-stop shop nákupní proces, optimalizovaný pro nákup vícero různých položek (např. vstupenky na festival + ubytování + jídlo + workshop)',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },



      {
        collapsibleId: 'sprava-plateb',
        title: 'Správa plateb',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'sprava-plateb',
            subtitle: 'Přehled plateb',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'sprava-plateb',
            subtitle: 'Refundace plateb na kredit zákazníka',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'sprava-plateb',
            subtitle: 'Storno poplatky',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'sprava-plateb',
            subtitle: 'Automatické párování příchozích plateb s objednávkami a fakturami',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'sprava-plateb',
            subtitle: 'Možnost ručního párování přijaté platby (na účet či v hotovosti) s objednávkou',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          }
        ]
      },




      {
        collapsibleId: 'onsite-platby',
        title: 'Platby na místě',
        standard: {
          progressPercent: 75
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'onsite-platby',
            subtitle: 'Pokladna - možnost zazanemant platby klientů v hotovosti',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'onsite-platby',
            subtitle: 'Rezervace s typem platby na místě',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'onsite-platby',
            subtitle: 'Možnost propojit platební termínál',
            standard: {
              icon: 'pi pi-times',
              color: Color.DANGER,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },




      {
        collapsibleId: 'crm',
        title: 'Funkce CRM',
        standard: {
          progressPercent: 90
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'crm',
            subtitle: 'Historie rezervací a objednávek vašich zákazníků',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'crm',
            subtitle: 'Historie docházky kurzisty',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'crm',
            subtitle: 'Zasílání vlastních jednorázových e-mailů účastníkům',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'crm',
            subtitle: 'Přehled zákaznických dat',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'crm',
            subtitle: 'Napojení na váš CRM systém',
            standard: {
              icon: 'pi pi-times',
              color: Color.DANGER,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },





      {
        collapsibleId: 'gdpr',
        title: 'Sběr a řízení GDPR souhlasů',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'gdpr',
            subtitle: 'Přehled udělených souhlasů a doby jejich platnosti',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'gdpr',
            subtitle: 'Správa stavu souhlasů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'gdpr',
            subtitle: 'Možnost nastavit vlastní různé typy souhlasů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'gdpr',
            subtitle: 'Chytré souhlasy, které se neptají zákazníků znovu na již udělený aktivní souhlas',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },




      {
        collapsibleId: 'dashboard',
        title: 'Dashboard s reporty',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
      },




      {
        collapsibleId: 'locations',
        title: 'Správa lokací / míst konání kurzů',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
      },




      {
        collapsibleId: 'customer-section',
        title: 'Sekce pro zákazníky',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'customer-section',
            subtitle: 'Historie provedených rezervací, objednávek a vystavených faktur',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          }
        ]
      },





      {
        collapsibleId: 'integration',
        title: 'Integrace prodejního formuláře do vašeho webu',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'integration',
            subtitle: 'Přizpůsobení vizuální podoby formuláře vašemu webu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          }
        ]
      },





      {
        collapsibleId: 'currencies',
        title: 'Příjem plateb v různých měnách (CZK, EUR)',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'currencies',
            subtitle: 'Příjem a záznam plateb v CZK',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'currencies',
            subtitle: 'Příjem a záznam plateb v EUR',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          }
        ]
      },





      {
        collapsibleId: 'fakturace',
        title: 'Automatická fakturace',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'fakturace',
            subtitle: 'Automatické vystavení faktury při platbě na firmu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'fakturace',
            subtitle: 'Nastavení vystavení faktury až po přijetí platby',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'fakturace',
            subtitle: 'Možnost automaticky vystavovat nejprve proforma faktury / výzvy k platbě',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'fakturace',
            subtitle: 'Fakturační profil organizace',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'fakturace',
            subtitle: 'Přednastavení popisu prodávaných položek na faktuře pomocí proměnných',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'fakturace',
            subtitle: 'Webové faktury s možností stažení do PDF',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'fakturace',
            subtitle: 'Napojení na vaše fakturační a účetní nástroje',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },




      {
        collapsibleId: 'vykazy-lektoru',
        title: 'Výkazy práce lektorů',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'vykazy-lektoru',
            subtitle: 'Sazby lektorů nastavitelné na úrovni organizace, kurzu i jednotlivých lekcí',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vykazy-lektoru',
            subtitle: 'Plánování obsazení lektorů na lekcích',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vykazy-lektoru',
            subtitle: 'Mobilní kalendář lekcí pro lektory s možností vykazování odvedené práce a dalších nákladů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vykazy-lektoru',
            subtitle: 'Podklady pro vyplácení mezd a faktur lektorům',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'vykazy-lektoru',
            subtitle: 'Měsíční reporty o nákladech na lektorné',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },





      {
        collapsibleId: 'prezencky',
        title: 'Prezenčky a sledování docházky účastníků',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'prezencky',
            subtitle: 'Prezenční listiny v mobilu pro lektory a koordinátory',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'prezencky',
            subtitle: 'Tisk prezenčních listin',
            standard: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
            custom: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
          },
          {
            collapsibleId: 'prezencky',
            subtitle: 'Sledování docházky účastníků',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'prezencky',
            subtitle: 'Omluvenky kurzistů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'prezencky',
            subtitle: 'Zázanam docházky kurzistů na lekci na pár kliknutí',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'prezencky',
            subtitle: 'Nahrazování omluvených lekcí',
            standard: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
            custom: {
              icon: 'pi pi-clock',
              color: Color.WARN,
            },
          },
        ]
      },





      {
        collapsibleId: 'slevy',
        title: 'Slevy a promokódy',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'slevy',
            subtitle: 'Slevy volitelné zákazníkem při rezervaci (studentská, věková, ...), jejichž nárok prokazuje zákazník na místě',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Skupinová sleva',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Sleva při registraci v páru',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Sourozenecká sleva pro registrace kdy rodič hlásí děti',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Sleva na základě předchozího nákupu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Sleva pro prvních N přihlášených, která vám pomůže motivovat publikum k nákupu těsně po spuštění rezervací',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Množstevní slevy',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Promokódy',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Vouchery a dárkové poukazy',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'slevy',
            subtitle: 'Šablony slev umožňující aktivovat přednastavené slevy u vybraných položek',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          }
        ]
      },





      {
        collapsibleId: 'role',
        title: 'Týmové role, přístupy a správa organizace',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'role',
            subtitle: 'Správa lektorů a jejich medailonků vč. fotek',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'role',
            subtitle: 'Udělení přístupů k účtu organizace pro registrované členy týmu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'role',
            subtitle: 'Evidence neregistrovaných členů týmu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },





      {
        collapsibleId: 'nextbestoffer',
        template: this.nextBestOfferTemplate,
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
      },






      {
        collapsibleId: 'branding',
        title: 'Vlastní branding',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'branding',
            subtitle: 'Možnost nastavit různé branding profily pro různé produkty a služby',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'branding',
            subtitle: 'Vlastní branding v e-mailové komunikaci',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'branding',
            subtitle: 'Vlastní branding v sekci pro klienty',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          }
        ]
      },







      {
        collapsibleId: 'exporty',
        title: 'Exporty',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'exporty',
            subtitle: 'Export vystavených faktur',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'exporty',
            subtitle: 'Export výkazů práce lektorů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'exporty',
            subtitle: 'Export uskutečněných lekcí',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'exporty',
            subtitle: 'Export docházky studentů',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },






      {
        collapsibleId: 'sprava-rezervaci',
        title: 'Správa stavu rezervací',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'sprava-rezervaci',
            subtitle: 'Přehled a filtrace přijatých rezervací dle stavu (podaná, přijatá, čeká na platbu, expirovaná, zrušená, potvrzená a zaplacená)',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'sprava-rezervaci',
            subtitle: 'Správa stavů rezervací',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },






      {
        collapsibleId: 'automatizace-potvrzeni',
        title: 'Automatizace potvrzení a upomínek',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'automatizace-potvrzeni',
            subtitle: 'Nastavitelné e-mailové potvrzení nákupu zákazníkovi',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'automatizace-potvrzeni',
            subtitle: 'Automatické připomínky zájemcům, kteří ještě nedokončili nákupu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'automatizace-potvrzeni',
            subtitle: 'Automatické upomínky klientům, kteří ještě nezplatili',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'automatizace-potvrzeni',
            subtitle: 'Možnost automatického zrušení rezervace klientům kteří nedokončili nákup a uvolnění místa pro zájemce na čekací listině',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'automatizace-potvrzeni',
            subtitle: 'Možnost nastavit termín na dokončení zatím nedokončeného nákupu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'automatizace-potvrzeni',
            subtitle: 'Možnost nastavit splatnost objednávky',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },







      {
        collapsibleId: 'schvalovani-rezervaci',
        title: 'Schvalování přijatých rezervací',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'schvalovani-rezervaci',
            subtitle: 'Automatické schvalování zájemců na základě volné kapacity',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'schvalovani-rezervaci',
            subtitle: 'Manuální schvalování zájemců administrátorem',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'schvalovani-rezervaci',
            subtitle: 'Automatické vyvažování rolí (např. muž/žena) během párových rezervací',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },






      {
        collapsibleId: 'wl',
        title: 'Čekací listiny',
        standard: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'wl',
            subtitle: 'Přijetí rezervací na čekací listinu při překročení kapacity',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'wl',
            subtitle: 'Automatické schválení první rezervace na čekací listině po uvolnění místa',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'wl',
            subtitle: 'Přehled rezervací na čekací listině',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },




      {
        collapsibleId: 'podpora',
        title: 'Podpora',
        standard: {
          progressPercent: 50
        },
        custom: {
          icon: 'pi pi-check',
          color: Color.SUCCESS,
        },
        subFeatures: [
          {
            collapsibleId: 'podpora',
            subtitle: 'Nepřetžitá podpora na e-mailu a chatu',
            standard: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
          {
            collapsibleId: 'podpora',
            subtitle: 'Podpora na telefonu',
            standard: {
              icon: 'pi pi-times',
              color: Color.DANGER,
            },
            custom: {
              icon: 'pi pi-check',
              color: Color.SUCCESS,
            },
          },
        ]
      },





    ]
  }
}
